var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import axios from "axios";
import { useApplicationContext } from "../../../../context/application-context";
import { message } from "antd";
import { INTG_ENDPOINTS } from "../../../../utils/endpoints";
import { ProgressBarLoader } from "../../../../components/loaders/progress-bar-loader";
const GetCodeMs = () => {
    const { tenantSettings } = useApplicationContext();
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user === null || user === void 0 ? void 0 : user.id) {
            // Function to extract code from URL
            const extractCodeFromURL = () => {
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get("code");
                if (code) {
                    // Call API using Axios with the extracted code
                    callApiWithCode(code);
                }
                else {
                    console.error("Code parameter not found in the URL");
                }
            };
            const getTokenByCode = (code) => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c;
                try {
                    const payload = {
                        email: user.email,
                        name: `${user.firstName} ${user.lastName}`,
                        userId: (_a = user === null || user === void 0 ? void 0 : user.id) === null || _a === void 0 ? void 0 : _a.toString(),
                        tenantId: tenantSettings.id.toString(),
                        isIntegrated: true,
                        code: code,
                        tenantUrl: window.location.origin,
                        msTeamsId: localStorage.getItem("ms-client-id"),
                    };
                    const response = yield axios({
                        method: "POST",
                        url: `${INTG_ENDPOINTS.GET_TOKEN_BY_CODE}`,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                        data: payload,
                    });
                    if (response.data.status === 200) {
                        return (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.accessToken;
                    }
                    else
                        return null;
                }
                catch (er) {
                    message.error("Something wrong in getting token....");
                }
            });
            // Function to make API call with the code
            const callApiWithCode = (code) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    let token = yield getTokenByCode(code);
                    const dataToSend = { token };
                    window.opener.postMessage(dataToSend, "*");
                    setTimeout(() => {
                        window.close();
                    }, 500);
                }
                catch (error) {
                    console.error("Error making API call:", error);
                }
            });
            // Call the function to extract code from URL on component mount
            extractCodeFromURL();
        }
        else {
            console.log("Inside else user app - get code");
        }
    }, []);
    return (_jsxs("div", Object.assign({ style: {
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        } }, { children: ["Setting up your calender....Please hold on", _jsx(ProgressBarLoader, {})] })));
};
export default GetCodeMs;
